export type HTTPMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH" | "HEAD" | "OPTIONS";


export class HTTPRequest {
    method: HTTPMethod
    url: string
    body: any
    headers:  { [key: string]: string }
    responseType: ResponseType
    signal?: AbortSignal;
    cache?: {
        enable?: boolean;
        ttlMs?: number;
        staleWhileRevalidate?: boolean;
        key?: string;
    }
}

export type HTTPErrorInfo = {
    status: number;
    message?: string;
    url: string;
    method: HTTPMethod;
}

export type HTTPErrorHandler = (error: HTTPErrorInfo) => void;

export interface HTTPClientInterface {
    retryCallback?: (request: HTTPRequest, errorCode: number, attemptNumber: number) => Promise<boolean>
    proxyCallback?: (request: HTTPRequest) => Promise<any>
    // Invoked when a request fails for good: a non-2xx response that will not be retried
    onError?: HTTPErrorHandler
    verbose: boolean
    setClientHeaders(headers: Record<string, string>): void
    execute(request: HTTPRequest, retryCount?: number): Promise<any>
}

export type ResponseType = "auto" | "json" | "text" | "blob" | "arrayBuffer";
